export enum JobStartType {
  ANYTIME = "ANYTIME",
  CONSENT = "CONSENT",
  DATE = "DATE"
}
